/**
 * This file sets configuration of the application settings used in
 * /src/app/app.environment.ts
 * (Which is called from /src/app/app.component.ts)
 * 
 *  it is set to either 'stage' for non-prod environments or 'prod' for production environments.
 * 
 * By using a variable here, we can do a search/replace in the build process to set the right environment
 * based on the branch/environment that needs to be deployed
 */


 export const BUILD_ENVIRONMENT = "qa";
//  export const BUILD_ENVIRONMENT = 'stage';
//  export const BUILD_ENVIRONMENT = 'dev';

 /*
 // If using this file locally, replace the line above with one that specifies the correct environment, like this:
 export const BUILD_ENVIRONMENT = 'stage';
 */

